import {ModulePages} from "../../core/module-pages";
import {ResumeProcessPage} from "./pages/resume-process.page";

export function ReportModule() {
  return (
    <ModulePages routes={[
      { path: '', absolutePath: '/admin/report-resume-process', render: props => <ResumeProcessPage {...props} /> }
    ]} />
  )
}